module.exports = __webpack_public_path__ + "img/icon-feedback.12ddbfa0.png";